export const OPERATION = {
  EQUALS: 'EQUALS',
  NOT_EQUALS: 'NOT_EQUALS',
  BETWEEN: 'BETWEEN',
  GT: 'GT',
  LT: 'LT',
  GTE: 'GTE',
  LTE: 'LTE',
  LAST_YEAR: 'LAST_YEAR',
  EXISTS: 'EXISTS',
  IN: 'IN',
  IN_CASE_INSENSITIVE: 'IN_CASE_INSENSITIVE',
  NOT_IN: 'NOT_IN',
  AML_CHECK: 'AML_CHECK',
  AML_CHECK_V2: 'AML_CHECK_V2',
  FUZZY_MATCH_SCORE_LT: 'FUZZY_MATCH_SCORE_LT',
  IDV_CHECK: 'IDV_CHECK',
  COMPANY_SANCTIONS_CATEGORIES: 'COMPANY_SANCTIONS_CATEGORIES',
  UBO_MISMATCH: 'UBO_MISMATCH',
  BANK_ACCOUNT_VERIFICATION: 'BANK_ACCOUNT_VERIFICATION',
} as const;

export const OPERATIONS = [
  OPERATION.EQUALS,
  OPERATION.NOT_EQUALS,
  OPERATION.BETWEEN,
  OPERATION.GT,
  OPERATION.LT,
  OPERATION.GTE,
  OPERATION.LTE,
  OPERATION.LAST_YEAR,
  OPERATION.EXISTS,
  OPERATION.IN,
  OPERATION.IN_CASE_INSENSITIVE,
  OPERATION.NOT_IN,
  OPERATION.AML_CHECK,
  OPERATION.AML_CHECK_V2,
  OPERATION.FUZZY_MATCH_SCORE_LT,
  OPERATION.IDV_CHECK,
  OPERATION.COMPANY_SANCTIONS_CATEGORIES,
  OPERATION.UBO_MISMATCH,
  OPERATION.BANK_ACCOUNT_VERIFICATION,
];

export const OPERATOR = {
  AND: 'and',
  OR: 'or',
} as const;
